<template>
  <div>
    <div class="login-container">
      <div class="login-wrap">
        <!--左侧log-->
        <div class="login-left">
          <img class="login-logo" src="../../assets/image/login/pc-kcidea.svg" alt />
          <img src="../../assets/image/login/login-left.png" class="left-img" />
          <!-- 联系我们 -->
          <div class="contact-box">
            <a href="http://www.kcidea.com" target="_blank" class="kcidea">南京昆虫软件有限公司</a>
            <div>
              <img src="../../assets/image/login/email.png" class="contact-email" />
              联系邮箱：support@kcidea.com
            </div>
          </div>
        </div>
        <!--右侧-->
        <div class="login-right">
          <!--右上角切换-->
          <div class="corner-switch">
            <img
              :src="require(`@/assets/image/login/corner-${weixinActive ? 'code' : 'comp'}.png`)"
              width="100%"
            />
          </div>
          <!--登录主体部分-->
          <div class="menu-content">
            <!--帐号密码登录-->
            <div id="account" class="menu-item">
              <div class="welcome">欢迎使用昆虫软件客户管理系统</div>
              <div>
                <div class="form-label">账号</div>
                <div class="form-line">
                  <img src="@/assets/image/login/pc-user.png" class="form-icon" />
                  <input class="form-input" type="text" placeholder="请输入账号" v-model="userName" />
                </div>
                <div class="form-label">密码</div>
                <div class="form-line">
                  <img src="@/assets/image/login/pc-password.png" class="form-icon" />
                  <input
                    id="passInput"
                    class="form-input"
                    :type="switchPassStatus ? 'password' : 'text'"
                    placeholder="请输入密码"
                    v-model="password"
                  />
                  <img
                    :src="require(`@/assets/image/login/pass-${switchPassStatus ? 'close' : 'show'}.png`)"
                    class="form-pass"
                    @click="switchPassStatus = !switchPassStatus"
                  />
                </div>
                <button class="form-btn" @click="login">登录</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-wrap">
        Copyright ©2018.南京昆虫软件有限公司, All rights reserved .
        <a href="https://beian.miit.gov.cn/" target="_blank" style="margin-top: -3px">
          备案号：苏ICP备11031502号-3
        </a>
        &nbsp;Email：support@kcidea.com
      </div>
    </div>
  </div>
</template>
<script>
import { login } from "@/api/user/index.js";
export default {
  data() {
    return {
      userName: "",
      password: "",
      weixinActive: true,
      switchPassStatus: true,
    };
  },
  methods: {
    login() {
      let userForm = {
        userName: this.userName,
        password: this.$utils.md5Password(this.password),
      };
      login(userForm)
        .then((res) => {
          //token存在本地localStorage
          window.localStorage.setItem("accessToken", res.data.token);
          this.$store.commit("setUserData", res.data);
          this.$router.replace("/home");
        })
        .catch(({ data }) => {
          this.$store.commit("setUserData", {});
          this.$MessageBox.MessageWarning(data.msg);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
/*整个login页面*/
.login-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url("../../assets/image/login/background-login.png") no-repeat center;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.login-container .login-wrap {
  display: flex;
  justify-content: space-between;
  width: 1080px;
  height: 600px;
  border-radius: 12px;
  overflow: hidden;
}

/*----------login页面左半边----------*/
.login-wrap .login-left {
  width: 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #f2f5fa;
}

.login-left .login-logo {
  width: 69px;
  height: 67px;
  margin-top: 40px;
  margin-left: 45px;
}

.login-left .left-img {
  width: 80%;
  margin: 0 auto;
}

.login-left .contact-box {
  position: relative;
  bottom: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  color: #464646;
  font-size: 12px;
  line-height: 20px;
}
.contact-box .kcidea {
  color: #464646;
}
.contact-box .kcidea:hover {
  color: #347df9;
  text-decoration: none;
}
.contact-box .contact-email {
  width: 12px;
  margin-right: 2px;
}

/*----------login页面右半边----------*/
.login-wrap .login-right {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 50%;
  padding: 80px;
  background-color: #ffffff;
}
/*右上角切换*/
.login-right .corner-switch {
  position: absolute;
  top: 5px;
  right: 5px;
  height: 40px;
  width: 80px;
  cursor: pointer;
}
/*右侧-主体部分*/
.menu-content .menu-item .welcome {
  margin-top: 30px;
  margin-bottom: 40px;
  font-size: 24px;
  font-weight: 600;
}

.menu-item .form-label {
  margin-bottom: 10px;
  color: #2a2a2a;
  font-size: 15px;
  font-weight: 600;
}

.form-line {
  position: relative;
  margin-bottom: 20px;
}

.form-line .form-icon {
  position: absolute;
  top: 50%;
  left: 8px;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
}
.form-line .form-pass {
  position: absolute;
  top: 50%;
  right: 8px;
  transform: translateY(-50%);
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.form-line .form-code {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  color: #206de6;
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
}

.form-line .form-input {
  height: 40px;
  line-height: 40px;
  width: 100%;
  color: #2a2a2a;
  border-color: #eaeaea;
  outline: none;
  border: 1px solid #eaeaea;
  border-radius: 4px;
  padding-left: 32px;
  padding-right: 15px;
}

.form-line .form-input::placeholder {
  color: #b9b9b9;
}
.menu-item .wechat-head {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
}
.wechat-head .prompt {
  text-align: center;
  line-height: 1.5;
  margin-top: 10px;
}

.menu-item .wechat-refresh {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  color: #333333;
  text-align: center;
  cursor: pointer;
  user-select: none;
}

.menu-item .wechat-refresh:hover {
  color: #206de6;
}

.wechat-img {
  width: 200px;
  height: 200px;
  text-align: center;
  margin: 10px auto;
  position: relative;
}

.wechat-img img {
  width: 200px;
  height: 200px;
  opacity: 1;
  border: 1px solid #ebebeb;
}

.wechat-error {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  line-height: 200px;
  background: rgba(255, 255, 255, 0.9);
  color: #000000;
}

.wechat-error span {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 500;
}

.form-btn {
  width: 100%;
  height: 40px;
  color: #fff;
  font-size: 15px;
  background: #347df9;
  border: 0px;
  border-radius: 6px;
  opacity: 1;
  letter-spacing: 5px;
  margin-top: 15px;
  cursor: pointer;
}

.wechat-btn {
  width: 100%;
  height: 40px;
  color: #fff;
  font-size: 16px;
  background: #347df9;
  border: 0px;
  border-radius: 6px;
  opacity: 1;
  letter-spacing: 5px;
  margin-top: 30px;
}

/****  select2相关样式   ****/
.form-select {
  width: 100%;
}

.form-select .wechat-select {
  width: 100%;
  height: 38px;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
  padding-left: 15px;
  margin-bottom: 20px;
  appearance: none;
  background-image: linear-gradient(45deg, transparent 50%, gray 50%),
    linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);
  background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px),
    calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
}

.form-select .wechat-select:focus {
  background-image: linear-gradient(45deg, #347df9 50%, transparent 50%),
    linear-gradient(135deg, transparent 50%, #347df9 50%), linear-gradient(to right, #ccc, #ccc);
  background-position: calc(100% - 15px) 1em, calc(100% - 20px) 1em, calc(100% - 2.5em) 0.5em;
  background-size: 5px 5px, 5px 5px, 1px 1.5em;
  background-repeat: no-repeat;
  border-color: #347df9;
  outline: 0;
}

.form-select .switch-account {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.switch-account .switch-label {
}
.switch-account .switch-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  user-select: none;
}
.switch-box span {
  color: #666;
  cursor: pointer;
}
.switch-box .toggler {
  position: relative;
  width: 42px;
  height: 22px;
  border-radius: 50px;
  background: #d9d9d9;
  margin: 0 10px;

  transition: all 0.2s linear;
}
.switch-box .toggler::before {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  height: 16px;
  width: 16px;
  border-radius: 50%;
  background: #fff;
  transition: all 0.2s linear;
}
.switch-box.active .toggler::before {
  left: 22px;
}
.switch-box.active .toggler {
  background-color: #347df9;
}
.switch-box .close {
  font-size: 14px;
  font-weight: 400;
  opacity: 1;
}

.select2 * {
  height: 40px !important;
  line-height: 40px !important;
  font-size: 16px;
}

.select2-results ul li {
  height: 35px !important;
  font-size: 16px;
}

.footer-wrap {
  line-height: 50px;
  color: #ededed;
  font-size: 14px;
  text-align: center;
  width: 100%;
  position: absolute;
  box-shadow: 0 -0.01235rem 0.02469rem 0 rgba(0, 0, 0, 0.1);
  z-index: 999;
  left: 0px;
  bottom: 0px;
}

.footer-wrap a {
  color: #00fff3;
}

/** 错误页面相关 **/
.error-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.error-wrap img {
  width: 600px;
  height: 360px;
}

.error-wrap .error-msg {
  margin-top: 50px;
  color: #202020;
  font-size: 25px;
}

.error-wrap a {
  margin-top: 25px;
  color: #1834f1;
}
</style>
